var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YieldList',{attrs:{"spaceId":_vm.space.Id,"channelId":_vm.channelId,"locationId":_vm.locationId,"meetingtypeId":_vm.meetingtypeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }